import { Box } from '@helvetia/components/Box'
import { Button } from '@helvetia/components/Button'
import { Col, Row } from '@helvetia/components/layout'
import LinkText from '@helvetia/components/LinkText'
import { MatchMedia } from '@helvetia/components/MatchMedia'
import Spinner from '@helvetia/components/Spinner'
import Text from '@helvetia/components/Text'
import dayjs from 'dayjs'
import * as React from 'react'
import { WithNamespaces, withNamespaces } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { LifecycleView } from '../_components/ConnectComponent'
import ContactBox from '../_components/HelvetiaContactBox'
import { Modal } from '../_components/Modal'
import { PageWrapper } from '../_components/summary/Summary.styles'
import { goToTermsAndConditionsLink } from '../_utils/links'
import { SaveAndRetreivePresenter } from './SaveAndRetreive.presenter'

export interface View extends LifecycleView {
  showLoading: () => void
  hideLoading: () => void
}

interface Props {
  presenter: SaveAndRetreivePresenter
}

interface State {
  validityDate: Date
  isLoading: boolean
  isModalOpen: boolean
}

export class SaveAndRetreiveRaw
  extends React.Component<Props & RouteComponentProps & WithNamespaces, State>
  implements View {
  private presenter: SaveAndRetreivePresenter

  constructor(props) {
    super(props)

    this.presenter = props.presenter
    this.presenter.initialize(this)

    this.state = {
      validityDate: null,
      isLoading: false,
      isModalOpen: false,
    }
  }

  setInitialValues = validityDate => {
    this.setState({
      validityDate,
    })
  }
  showLoading = () => this.setState({ isLoading: true })

  hideLoading = () => this.setState({ isLoading: false })

  showModal = () => this.setState({ isModalOpen: true })

  hideModal = () => this.setState({ isModalOpen: false })

  onContinue = () => {
    this.presenter.onSave()
  }

  render() {
    const { t } = this.props
    const { validityDate, isLoading, isModalOpen } = this.state

    if (!validityDate || isLoading) return <Spinner size="xl" />

    if (isModalOpen)
      return (
        <Modal
          buttonText={t('buttons.accept')}
          onClose={this.presenter.onHideModalHandler}
          title={
            <>
              <MatchMedia onlyMobile>
                <Text size="sBold">{t('modal.save.title')}</Text>
              </MatchMedia>
              <MatchMedia tablet>
                <Text size="sBold">{t('modal.save.title')}</Text>
              </MatchMedia>
            </>
          }
        >
          <Text size="s" as="p" color="black">
            {t('modal.save.p1')}
          </Text>
          <Text size="s" as="p" color="black">
            {t('modal.save.p2')}
          </Text>
          <Text size="s" as="p" color="black">
            {t('contactMe.questions')}
            <Text
              size="sBold"
              as="span"
              color="black"
            >{` marine@helvetia.ch`}</Text>
          </Text>
        </Modal>
      )

    return (
      <PageWrapper>
        <Row>
          <Text as="p" color="black" size="m">
            {t('saveAndRetreive.title')}
          </Text>
        </Row>

        <Row verticalGutter marginTop="xxs">
          <Col verticalGutter mobile={12} tablet={12} desktop={12}>
            <Text as="div" size="s" color="black">
              {t('saveAndRetreive.p1')}
              <Text as="span" size="sBold" color="black">
                {dayjs(validityDate)
                  .add(3, 'month')
                  .format('DD.MM.YYYY')}
              </Text>
            </Text>
          </Col>
          <Col verticalGutter mobile={12} tablet={12} desktop={12}>
            <Text as="p" size="s" color="black">
              {t('saveAndRetreive.p2')}
            </Text>
          </Col>
        </Row>
        <Row marginTop="s">
          <Col verticalGutter mobile={12} tablet={12} desktop={12}>
            <Text as="div" size="sBold" color="black" uppercase>
              {t('summary.subtitle.generalTerms')}
            </Text>
          </Col>
          <Col verticalGutter mobile={12} tablet={12} desktop={12}>
            <Text as="div" size="s" color="black">
              {t('summary.generalTerms.wish')}

              <LinkText
                text={t('summary.generalTerms.link')}
                color="primary"
                onClick={goToTermsAndConditionsLink}
              />
            </Text>
          </Col>
        </Row>

        <Row verticalGutter marginTop="s" marginBottom="xs">
          <Col verticalGutter mobile={12} tablet={3} desktop={3}>
            <Button primary onClick={this.onContinue}>
              {t('buttons.save')}
            </Button>
          </Col>
          <Col verticalGutter mobile={12} tablet={3} desktop={3}>
            <Button grey onClick={this.presenter.onBack}>
              {t('buttons.back')}
            </Button>
          </Col>
        </Row>
        <Row verticalGutter>
          <Col>
            <ContactBox />
          </Col>
        </Row>
      </PageWrapper>
    )
  }
}

export const SaveAndRetreiveView = withNamespaces()(
  withRouter(SaveAndRetreiveRaw),
)
